import { Component, OnInit } from '@angular/core';
import {CustomerActionService} from "../services/customer-action.service";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {CustomerActionModel} from "../../dto/customerActionModel";

@Component({
  selector: 'app-customer-action',
  templateUrl: './customer-action.component.html',
  styleUrls: ['./customer-action.component.css']
})
export class CustomerActionComponent implements OnInit {
  actionModel: CustomerActionModel|null;
  token: string|null;
  displayThankYou = false;

  constructor(
    private customerActionService: CustomerActionService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      const tokenParam = params['token'];
      this.token = tokenParam;
      this.customerActionService.getLinkAction(tokenParam).subscribe(value => {

        // action here

        this.actionModel = value;


      }, error => {


      });

    });
  }


  confirmAction() {
    this.customerActionService.confirmAction(this.token).subscribe(value => {
      if ( value.redirectUrl ) {
        window.location.href = value.redirectUrl;
        return;
      }

      this.displayThankYou = true;

    });
  }

  denyAction() {
    this.customerActionService.denyAction(this.token).subscribe(value => {
      if ( value.redirectUrl ) {
        window.location.href = value.redirectUrl;
        return;
      }

      this.displayThankYou = true;

    });
  }

}
